<template>
    <button class="w-6" @click="$pop('search')"> 
        <IconSearch class='icon-hover-grey-to-white' />
    </button>
</template>

<script>
    export default {
        data() {
            return {
                open: false
            }
        },

        methods: {
            toggle() {
                this.open = !this.open
            }
        }
    }
</script>